export const brandConfig = {
    name: "STRIKE",

    fullName:
        "STRIKE Urban Playground",

    accountName:
        "STRIKE FIÓK",

    defaultUserName:
        "Strike játékos",

    legal: {
        companyName:
            "Ötlet Outlet Kft.",

        registeredOffice:
            "1136 Budapest, Tátra utca 5/A. 1. em. 2.",

        companyRegistrationNumber:
            "01-09-436287",

        taxNumber:
            "27510478-2-41",

        representative:
            "Nyári Zsolt ügyvezető",

        email:
            "info@strike.hu",

        phone:
            "+36 30 120 2326",

        website:
            "strike.hu",

        serviceLocationName:
            "STRIKE Urban Playground",

        serviceLocationAddress:
            "1136 Budapest, Pannónia utca 46/A.",

        bankAccount: {
            accountHolder:
                "ÖTLET OUTLET Kft.",

            bank:
                "OTP Bank",

            accountNumber:
                "11742087-24294137-00000000",

            iban:
                "HU32117420872429413700000000",

            swift:
                "OTPVHUHB",
        },
    },

    colors: {
        primary:
            "#f5a400",

        primaryHover:
            "#ffb31a",

        background:
            "#0b0b0b",

        textOnPrimary:
            "#000000",

        primaryBorder:
            "#806000",

        primaryText:
            "#ffc94d",
    },
};